import React from 'react';
import TokenService from '../services/TokenService';
import { useSnackbar } from 'notistack';

import {
    Card,
    CardContent,  
    Skeleton,

}
    from '@mui/material';


function BottleSlips(props) {
   
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [bottleSlips, setBottleSlips] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    React.useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        setIsLoading(true);
        let postData = {
            orderGUID: props.PickupRequest.OrderGUID
        }
        TokenService.post(postData, 'Order_GetBottleSlip')
            .then((response) => {
                setIsLoading(false);
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let bottleSlipsAdded = JSON.parse(jsonData.BottleSlips);
                    setBottleSlips(bottleSlipsAdded);
                }

            })
            .catch((response) => {
                setIsLoading(false);
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />

        </div>
    }

    function buildTotals() {
        if (bottleSlips.length > 0) {
            let totalQuantity = 0;
            for (let i = 0; i < bottleSlips.length; i++) {
                totalQuantity += parseInt(bottleSlips[i].Quantity);
            }

            return <Card style={{ marginTop: '25px', marginBottom: '25px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto', backgroundColor: 'var(--sipzee-green-3)' }}>
                <CardContent>


                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', fontSize: '18pt' }}>
                        Bottle Slips: <span style={{ marginLeft: '5px' }}>{bottleSlips.length}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold', fontSize: '18pt' }}>
                        Total Quantity: <span style={{ marginLeft: '5px' }}>{totalQuantity}</span>
                    </div>
                </CardContent>
            </Card>
        }
    }

    return (<div style={{ height: '90vh', width: '100%', minWidth:'300px', display: 'flex', flexDirection: 'column', backgroundColor: '#f5f5f5' }}>
        

            {isLoading ?
                buildSkeleton()
                :
                <>
                    {buildTotals()}

                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        {

                            bottleSlips.map((bottleSlip, index) => {
                                return <Card style={{ margin: '15px', maxWidth: '500px', minWidth: '300px', marginLeft: 'auto', marginRight: 'auto', opacity: bottleSlip.isLoading == undefined ? 1 : bottleSlip.isLoading ? .5 : 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
                                        <div style={{ width: '40px' }}></div>
                                        <div style={{ textAlign: 'center', marginTop: '20px' }}>Quantity: {bottleSlip.Quantity}</div>

                                        <div style={{ width: '40px' }}></div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                                        <img style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            src={bottleSlip.ImagePath}
                                        />
                                    </div>
                                </Card>
                            })
                        }
                    </div>
                </>
            }



      
    </div>)
}

export default BottleSlips;